import { RemoteComponent } from 'mf-dynamic-remote-component';
import { observer } from 'mobx-react';
import React, { Suspense } from 'react';
import { Spinner, GridColumn, Grid } from 'telia-front-react';
const ssoModule = (ssoUrl, module) => RemoteComponent({
    path: `${ssoUrl}/js/sso-remote.js`,
    scope: 'sso',
    module,
});
const SsoDropdownContent = ({ url, rootStore }) => {
    const { tier, ssoBackendURL, brand } = rootStore.environmentStore;
    const { client } = rootStore.ssoStore;
    const App = React.lazy(() => ssoModule(ssoBackendURL, './App'));
    const ssoConfig = {
        brand: brand,
        apiUrl: `${ssoBackendURL}/api`,
        env: tier,
    };
    return (React.createElement(Suspense, { fallback: React.createElement(Grid, { style: { minHeight: '400px', marginRight: 0, marginBottom: 0 }, align: ['center-xs'], className: "text-center" },
            React.createElement(GridColumn, { align: ['middle-xs'] },
                React.createElement(Spinner, null))) },
        React.createElement(App, { initialUrl: url, config: { ...ssoConfig, env: tier }, client: client })));
};
export default observer(SsoDropdownContent);
//# sourceMappingURL=SsoModule.js.map